module.exports = __webpack_public_path__ + "static/media/placeholderImage.d6f42348.svg";